/*
 * reducers configuration
 */

import { combineReducers } from 'redux';

// import reducers
import appReducer from '../components/App/store/reducers';
import consignerReducer from '../components/Consigner/store/reducers';
import thirdPartyReducer from '../components/ThirdParty/store/reducers';
import createDemandReducer from '../components/CreateDemand/store/reducers';
import operatorReducer from '../components/Operator/store/reducers';
import operationsReducer from '../components/Operations/store/reducers';
import placementReducer from '../pages/Placement/store/placement.reducer';
import places from 'components/SearchPlaces/store/reducers';
import toaster from 'components/Toaster/reducer';
import updateVehicle from 'components/UpdateVehicle/store/reducer';
import lms from 'pages/lms/store/lms.reducers';
import transactions from 'pages/transactions/store/transactions.reducers';
import ticketing from 'pages/ticketing/store/reducers';
import cms from 'pages/cms/store/cms.reducers';
import issueCreation from 'pages/IssueCreation/store/issueCreation.reducers';
import permissions from 'pages/permissions/store/permissions.reducers';
import createBulkDemandPTL from 'components/CreateDemandPTL/store/reducers';
import laneRateDashboard from 'components/LaneRateDashboard/store/reducers';
import ptlBulkMIS from 'components/PTLBulkMIS/store/reducers';
import ptlFreightUpload from 'components/PTLFreightUpload/store/reducers';
import ptlTaskDashBoard from 'components/PTLTaskDashBoard/store/reducers';

export default combineReducers({
  app: appReducer,
  consigner: consignerReducer,
  thirdParty: thirdPartyReducer,
  operator: operatorReducer,
  createDemand: createDemandReducer,
  operations: operationsReducer,
  placement: placementReducer,
  places,
  toaster,
  updateVehicle,
  lms,
  transactions: transactions,
  ticketing: ticketing,
  cms: cms,
  issueCreation: issueCreation,
  permissions,
  createBulkDemandPTL,
  ptlBulkMIS,
  laneRateDashboard,
  ptlFreightUpload,
  ptlTaskDashBoard,
});
